<header class="app-header">
  <div class="header-inner">
    <button class="burger" type="button" (click)="sidebarService.toggle()" aria-label="Ouvrir/fermer le sommaire">
      ☰
    </button>

    <a routerLink="/manuel" class="brand">
      <span class="brand-text">
        <img src="/images/youth-logo.png" alt="Logo de YouthConnekt Cameroon" class="brand-logo" />
        <small>{{ 'common_manual_label' | translate }}</small>
      </span>
    </a>

    <div class="header-spacer"></div>

    <a routerLink="/manuel/glossary" class="header-link">{{ 'glossary' | translate }}</a>
    <a routerLink="/manuel/support" class="header-link">{{ 'support' | translate }}</a>
    
    <!-- Bouton de changement de langue -->
    <button class="language-btn" (click)="toggleLanguage()" [title]="'language' | translate">
      {{ currentLanguage | uppercase }}
    </button>

    <a href="https://youthconnektcameroon.org" target="_blank" rel="noopener" class="header-cta">
      <span class="cta-label">{{ 'open_site' | translate }}</span>
      <span class="cta-icon" aria-hidden="true">↗</span>
    </a>
  </div>
</header>